import { render, staticRenderFns } from "./PaperItem.vue?vue&type=template&id=df7a2d70&lang=html"
import script from "./PaperItem.vue?vue&type=script&lang=js"
export * from "./PaperItem.vue?vue&type=script&lang=js"
import style0 from "./PaperItem.vue?vue&type=style&index=0&id=df7a2d70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports